import { alpha, styled } from '@mui/material';
import { FONT_DISPLAY, FONT_MONO } from 'themes/tokens';

export const IdentityCard = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2.5),
  padding: theme.spacing(2.5),
  borderRadius: '14px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
}));

export const InitialsAvatar = styled('div')(({ theme }) => ({
  flex: 'none',
  display: 'grid',
  placeItems: 'center',
  width: 56,
  height: 56,
  borderRadius: '16px',
  fontFamily: FONT_DISPLAY,
  fontSize: '1.3rem',
  fontWeight: 700,
  letterSpacing: '0.02em',
  color: theme.palette.accent.contrastText,
  backgroundColor: theme.palette.accent.main,
  userSelect: 'none',
}));

export const IdentityMeta = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  minWidth: 0,
}));

export const UsernameText = styled('span')(({ theme }) => ({
  fontFamily: FONT_MONO,
  fontSize: '0.82rem',
  color: theme.palette.text.secondary,
}));

export const FormCard = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2.5),
  borderRadius: '12px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.03),
}));

export const FormActions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1.5),
}));

export const InlineFieldRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  flexWrap: 'wrap',
}));
